module.exports = __webpack_public_path__ + "img/组 8736@2x.327336fd.png";